export default __webpack_public_path__ + "static/media/ghost-three-step_new.004b0705.png";